import script from "./RuleOf40View.vue?vue&type=script&setup=true&lang=ts"
export * from "./RuleOf40View.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__